/**
 * CONFIGURACIÓN DE BRANDING
 * Colores, logos, tipografías y elementos visuales
 */

export const brandingConfig = {
  logo: "/zero_logo.svg",
  favicon: "/favicon.ico",
  colors: {
    primary: "#00202c",
    secondary: "#00B3E6",
    accent: "#ED6000",
    accent2: "#C5A4F4",
    accent3: "#CBFD3C",
    link: "#0059C8",
    black: "#000000",
    white: "#F5F5F5",
    // Colores de estado
    error: "#DC2626",
    warning: "#F59E0B",
    success: "#10B981",
    info: "#3B82F6",
    gray: {
      50: "#F9FAFB",
      100: "#F3F4F6",
      200: "#E5E7EB",
      300: "#D1D5DB",
      400: "#9CA3AF",
      500: "#6B7280",
      600: "#4B5563",
      700: "#374151",
      800: "#1F2937",
      900: "#111827",
    },
  },
  fonts: {
    primary: "Sweet Sans",
    secondary: "Super Ground",
    weights: {
      regular: 400,
      medium: 500,
      bold: 700,
      heavy: 900,
    },
  },
};
